import React from "react";
import { Link } from "react-router-dom";
import { serviceAreas } from "../data/serviceAreas";

export const ServiceAreas = () => {
  return (
    <section id="service-areas" className="text-center">
      <div className="container">
        <div className="section-title">
          <h1>Pressure Washing Service Areas Near Clinton, NC</h1>
          <p>
            We provide pressure washing and soft washing services in Clinton, NC and nearby
            communities across Sampson County and surrounding counties.
          </p>
        </div>

        <div className="row service-area-grid">
          {serviceAreas.map((area) => (
            <div key={area.slug} className="col-sm-6 col-md-4 service-area-grid-item">
              <Link
                to={`/service-areas/${area.slug}`}
                className="service-area-card"
                aria-label={`Pressure washing services in ${area.city}, ${area.state}`}
              >
                <h3>
                  {area.city}, {area.state}
                </h3>
                <p>{area.metaDescription}</p>
                <span>View area page</span>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
